import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthService } from "../../../hooks/useAuthService.tsx";
import { useAppStore } from "../../../hooks/useStores.tsx";
import ConfirmationPopup from "../../common/ConfirmationPopup/ConfirmationPopup.tsx";
import RecentLoginPopup from "../RecentLoginPopup/RecentLoginPopup.tsx";

interface MfaRemovalPopupProps {
	open: boolean;
	onSuccess?: () => void;
}

const MfaRemovalPopup = ({ open, onSuccess }: MfaRemovalPopupProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "mfa.mfaRemoval" });
	const [removingMfa, setRemovingMfa] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const [showRecentLoginPopup, setShowRecentLoginPopup] = useState<boolean>(false);
	const { unenrollTotpMfa } = useAuthService();
	const { authStore, uiStore } = useAppStore();

	const handleRemoveMfa = async () => {
		setRemovingMfa(true);
		setError("");

		try {
			await unenrollTotpMfa();
			authStore.isMfaSetupCompleted = false;
			
			// Show success toast
			uiStore.showSnackBarAlert("success", t("successMessage"), 5000);
			
			if (onSuccess) {
				onSuccess();
			}
		} catch (error: any) {
			if (error.code === "auth/requires-recent-login") {
				setShowRecentLoginPopup(true);
			} else {
				setError(t("error.genericError"));
			}
		} finally {
			setRemovingMfa(false);
		}
	};

	return (
		<>
			<ConfirmationPopup
				open={open}
				description={t("description")}
				confirmButtonText={t("removeButton")}
				onClose={() => {}}
				onClick={handleRemoveMfa}
				loading={removingMfa}
				disabled={removingMfa}
				hideCancel={true}
				hideCloseIcon={true}
				errorMessage={error}
			/>

			<RecentLoginPopup open={showRecentLoginPopup} loading={removingMfa} disabled={removingMfa} />
		</>
	);
};

export default MfaRemovalPopup;
